import React from "react";
import { HeaderModule } from '../../components/home/HeaderModule';
import { TuneOutlined } from "@mui/icons-material";
import { SettingsSurvey } from "../../components/surveys/settings/SettingsSurvey";
import { useSettings } from "../../hooks/useSettings";

export const QuantiumSettings = () => {

    const { settings, updateSettings } = useSettings();

    return (
        <>
            <HeaderModule 
                icon={ <TuneOutlined htmlColor="rgba(0, 0, 0, .6)" /> }
                title='Ajustes'
            />

            { Object.values(settings).length > 0 && <SettingsSurvey data={ settings } action={ updateSettings } /> }
        </>
    )
}